import type { SelectedQueryFilter } from '../../store/quick-find';

/**
 * Given a query and a list of selected query filters, return the query text
 * without the display text of the selected query filters.
 */
export const getQueryWithoutSelectedQueryFilters: (
	inputQuery: string,
	selectedQueryFilters: SelectedQueryFilter[],
) => string = (inputQuery: string, selectedQueryFilters: SelectedQueryFilter[]): string => {
	let filteredQuery = inputQuery;

	for (const selectedQueryFilter of selectedQueryFilters) {
		filteredQuery = filteredQuery.replace(selectedQueryFilter.displayText, '');
	}

	return filteredQuery;
};
